import React, { useEffect } from 'react';
import './styles/main.css';
import AppRoutes from './routes/AppRoutes';

export default function App() {
	// Inject Google Fonts links for Montserrat
	useEffect(() => {
		const preconnect = document.createElement('link');
		preconnect.rel = 'preconnect';
		preconnect.href = 'https://fonts.googleapis.com';
		const preconnect2 = document.createElement('link');
		preconnect2.rel = 'preconnect';
		preconnect2.href = 'https://fonts.gstatic.com';
		preconnect2.crossOrigin = 'anonymous';

		const stylesheet = document.createElement('link');
		stylesheet.rel = 'stylesheet';
		stylesheet.href =
			'https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap';

		document.head.appendChild(preconnect);
		document.head.appendChild(preconnect2);
		document.head.appendChild(stylesheet);

		return () => {
			document.head.removeChild(preconnect);
			document.head.removeChild(preconnect2);
			document.head.removeChild(stylesheet);
		};
	}, []);

	return (
		// Apply Montserrat app-wide (with fallbacks)
		<div style={{ fontFamily: 'Montserrat' }}>
			<AppRoutes />
		</div>
	);
}
